import type { JSX } from 'react';
import { Controller, FieldValues } from 'react-hook-form';

import { FormFieldWrapperProps } from '@/widgets/ServiceFormTemplate';

import { FormInput } from '../FormInput/FormInput';
import { CheckboxGroup, CheckboxOption } from './CheckboxGroup';

interface FormCheckboxGroupProps<T extends FieldValues> extends FormFieldWrapperProps<T> {
  options: CheckboxOption[];
  label?: string;
  className?: string;
  errorMessage?: string;
  required?: boolean;
}

export function FormCheckboxGroup<T extends FieldValues = FieldValues>({
  name,
  control,
  options,
  label,
  className,
  errorMessage,
  required,
}: FormCheckboxGroupProps<T>): JSX.Element {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }): JSX.Element => (
        <FormInput
          label={label}
          required={required}
          errorMessage={errorMessage ?? error?.message}
          className={className}
        >
          <CheckboxGroup
            options={options}
            value={(field.value as string[]) ?? []}
            onChange={(next): void => field.onChange(next)}
          />
        </FormInput>
      )}
    />
  );
}
